import { Injectable } from "@angular/core";
import { CanActivate, Router } from "@angular/router";
import { encryptStorage } from "src/app/shared/utils/storage/storage";

@Injectable({
  providedIn: "root",
})
export class AuthGuardService implements CanActivate {
  constructor(private route: Router) {}

  canActivate() {
    if (
      encryptStorage.getItem("@authorization") == null ||
      encryptStorage.getItem("@authorization") == ""
    ) {
      this.route.navigate(["/login"]);
      return false;
    } else return true;
  }
}
